import React from 'react';
import { SonForm } from '../../../_lib/Form2';
import { AcceptDeclineForm } from '../../../_lib/Form2/standardForms/AcceptDeclineForm/AcceptDeclineForm';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export type RssFeedDeleteForm = SonForm<any>;

export function RssFeedDeleteForm({ form, onSuccess }: { form: RssFeedDeleteForm; onSuccess: () => void }) {
  const { t } = useSonTranslation('RssFeed');

  return (
    <AcceptDeclineForm
      id="rss-feed-delete-form"
      form={form}
      onSuccess={onSuccess}
      headline={t('editView.delete.removeFeed')}
      messageSending={t('editView.delete.sending')}
      messageSuccess={t('editView.delete.success')}
      messageFail={t('editView.delete.fail')}
    />
  );
}
